import React from 'react';
import { Chip } from '@mui/material';
import { getEventApprovalStatusStyle } from '../eventApprovalStatusStyles';

const EventApprovalStatusBadge = ({ status }) => {
  const config = getEventApprovalStatusStyle(status);

  return (
    <Chip
      label={config.label}
      size="small"
      sx={{
        height: 24,
        fontWeight: 600,
        fontSize: '0.75rem',
        bgcolor: config.bgcolor,
        color: config.color,
        borderRadius: '6px',
      }}
    />
  );
};

export default EventApprovalStatusBadge;
